module.exports = __webpack_public_path__ + "static/hero-1-e3b1e56d93a3589c7f80719df59876ce.mp4";